export default __webpack_public_path__ + "static/media/image.gogo-cargo.b806db8b.png";